/**
 * An authenticated user role
 */
export enum Role {
  SuperAdmin = 'superadmin',
  ProjectManager = 'project_manager',
  AppAdmin = 'app_admin',
  AppManager = 'app_manager'
}
